// Import model
import { FilterObjectTaskRequest } from '../models/FilterObjectTaskRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { ObjectTaskCondition } from '../models/ObjectTaskCondition';
import { ObjectTaskFields } from '../models/ObjectTaskFields';
import { ObjectTaskIndexedFields } from '../models/ObjectTaskIndexedFields';

// Import dependency serializers (for complex types)
import { ObjectTaskConditionSerializer } from './ObjectTaskConditionSerializer';
import { ObjectTaskFieldsSerializer } from './ObjectTaskFieldsSerializer';
import { ObjectTaskIndexedFieldsSerializer } from './ObjectTaskIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for FilterObjectTaskRequest - handles JSON serialization and deserialization with type validation
 */
export class FilterObjectTaskRequestSerializer {
  /**
   * Deserializes a JSON string into a FilterObjectTaskRequest instance
   */
  static deserialize(json: string): FilterObjectTaskRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a FilterObjectTaskRequest instance
   */
  static fromObject(obj: any): FilterObjectTaskRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to FilterObjectTaskRequest');
    }


    const instance: FilterObjectTaskRequest = {
      top: obj['top'] as number | undefined,
      skip: obj['skip'] as number | undefined,
      orderBy: obj['orderBy'] as ObjectTaskIndexedFields | undefined,
      reverseOrder: obj['reverseOrder'] as boolean | undefined,
      view: obj['view'] as string | undefined,
      fields: obj['fields'] ? (obj['fields'] as any[]).map((item: any) =>
        item as ObjectTaskFields
      ) : [] as any,
      criteria: obj['criteria'] ? (obj['criteria'] as any[]).map((item: any) =>
        ObjectTaskConditionSerializer.fromObject(item)
      ) : [] as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of FilterObjectTaskRequest instances
   */
  static deserializeArray(json: string): FilterObjectTaskRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a FilterObjectTaskRequest instance to a JSON string
   */
  static serialize(instance: FilterObjectTaskRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a FilterObjectTaskRequest instance to a plain object
   */
  static toObject(instance: FilterObjectTaskRequest): any {
    return {
      'top': instance.top,
      'skip': instance.skip,
      'orderBy': instance.orderBy,
      'reverseOrder': instance.reverseOrder,
      'view': instance.view,
      'fields': instance.fields?.map((item: any) =>
        item
      ),
      'criteria': instance.criteria?.map((item: any) =>
        ObjectTaskConditionSerializer.toObject(item)
      ),
    };
  }

  /**
   * Serializes an array of FilterObjectTaskRequest instances to a JSON string
   */
  static serializeArray(instances: FilterObjectTaskRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
